export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
    });
};

export default scrollToTop;